<p-toast position="top-center" />
<p-table
  #controllerListTbl
  [value]="controllers()"
  stripedRows
  [paginator]="true"
  [rows]="15"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} controllers"
  [rowsPerPageOptions]="[5, 10, 15, 20, 50, 100]"
  size="small"
  [loading]="isLoading()"
  (onRowSelect)="goToDetail($event)"
  selectionMode="single"
  [globalFilterFields]="[
    'name',
    'serialNumber',
    'installationName',
    'deviceClientVersion',
    'mainFWVersion',
  ]"
  class="w-full"
>
  <ng-template #caption>
    <div class="flex">
      <p-iconfield class="ml-auto">
        <p-inputicon class="pi pi-search" />
        <input
          #searchInput
          type="text"
          pInputText
          placeholder="Search"
          (input)="
            controllerListTbl.filterGlobal($event.target.value, 'contains')
          "
        />
        <p-inputicon
          class="pi pi-times text-red-600 hover:cursor-pointer"
          (click)="searchInput.value = ''; controllerListTbl.clear()"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th class="hidden xl:table-cell" pSortableColumn="deviceStatus">
        Status <p-sortIcon field="deviceStatus" />
      </th>
      <th class="xl:hidden"></th>

      <th class="hidden xl:table-cell" pSortableColumn="name">
        Name <p-sortIcon field="name" />
      </th>
      <th>Type</th>

      <th class="hidden md:table-cell">Serialnumber</th>
      <th class="md:hidden">Serial No.</th>

      <th>Installation</th>

      <th class="hidden md:table-cell" pSortableColumn="activated">
        Activated <p-sortIcon field="activated" />
      </th>
      <th class="hidden xl:table-cell" pSortableColumn="mainFWVersion">
        FW Version <p-sortIcon field="mainFWVersion" />
      </th>
      <th class="hidden xl:table-cell" pSortableColumn="lastUpdate">
        Last Update <p-sortIcon field="lastUpdate" />
      </th>
      <th class="hidden xl:table-cell" pSortableColumn="deviceClientVersion">
        Device client version <p-sortIcon field="deviceClientVersion" />
      </th>
      @if (showAdminFields()) {
        <th
          class="hidden lg:table-cell !text-center"
          pSortableColumn="emCount"
          pTooltip="Energy meters"
        >
          <i class="pi pi-gauge"></i><p-sortIcon field="emCount" class="ml-2" />
        </th>
        <th
          class="hidden lg:table-cell !text-center"
          pSortableColumn="inverterCount"
          pTooltip="Inverters (PV)"
        >
          <i class="fa-solid fa-solar-panel"></i
          ><p-sortIcon field="inverterCount" class="ml-2" />
        </th>
        <th
          class="hidden lg:table-cell !text-center"
          pTooltip="EMS (Battery systems)"
          pSortableColumn="emsCount"
        >
          <i class="fa-solid fa-car-battery"></i
          ><p-sortIcon field="emsCount" class="ml-2" />
        </th>
        <th
          class="hidden lg:table-cell !text-center"
          pTooltip="IO Addon"
          pSortableColumn="ioAddonCount"
        >
          <i class="fa-solid fa-microchip"></i
          ><p-sortIcon field="ioAddonCount" class="ml-2" />
        </th>
      }
    </tr>
    @if (showAdminFields()) {
      <tr class="hidden xl:table-row">
        <th colspan="2">
          <p-columnFilter
            field="deviceStatus"
            matchMode="equals"
            [showMenu]="false"
          >
            <ng-template #filter let-value let-filter="filterCallback">
              <p-select
                [options]="statuses"
                (onChange)="filter($event.value)"
                placeholder="Status"
                [showClear]="true"
                style="min-width: 10rem"
              >
                <ng-template let-option #item>
                  <p-chip
                    [label]="option.value"
                    [icon]="iconsStyles.getDeviceStatusIcon(option.value)"
                    [style]="
                      iconsStyles.getDeviceStatusBackgroundStyle(option.value)
                    "
                    class="w-35 h-6 place-content-center text-sm"
                  />
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </th>
        <th colspan="3">
          <p-columnFilter
            field="deviceType"
            matchMode="equals"
            [showMenu]="false"
          >
            <ng-template #filter let-value let-filter="filterCallback">
              <p-select
                [options]="controllerTypes"
                (onChange)="filter($event.value)"
                placeholder="Type"
                [showClear]="true"
              >
                <ng-template let-option #item>
                  {{ option.label }}
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </th>
        <th colspan="8">
          <p-columnFilter
            field="activated"
            matchMode="equals"
            [showMenu]="false"
          >
            <ng-template #filter let-value let-filter="filterCallback">
              <p-select
                [options]="activatedStatuses"
                (onChange)="filter($event.value)"
                placeholder="Activated"
                [showClear]="true"
              >
                <ng-template let-option #item>
                  {{ option.label }}
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </th>
      </tr>
    }
  </ng-template>
  <ng-template #body let-controller>
    <tr [pSelectableRow]="controller">
      <td class="hidden xl:table-cell">
        <p-chip
          [label]="controller.deviceStatus"
          [icon]="iconsStyles.getDeviceStatusIcon(controller.deviceStatus)"
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(controller.deviceStatus)
          "
          class="w-35 h-6 place-content-center text-sm"
        />
      </td>
      <td
        class="xl:hidden"
        [style]="
          iconsStyles.getDeviceStatusBackgroundStyle(controller.deviceStatus)
        "
      >
        <i
          [class]="iconsStyles.getDeviceStatusIcon(controller.deviceStatus)"
        ></i>
      </td>

      <td class="hidden xl:table-cell">{{ controller.name }}</td>

      <td>{{ controller.deviceType }}</td>
      <td
        class="hidden md:table-cell"
        (click)="
          $event.stopPropagation();
          customFunctions.copyText(controller.serialNumber);
          showCopiedMessage()
        "
      >
        <i class="fa-solid fa-copy"></i> {{ controller.serialNumber }}
      </td>
      <td class="md:hidden">{{ controller.serialNumber }}</td>
      <td>{{ controller.installationName }}</td>
      <td class="hidden md:table-cell">
        <i
          [class]="iconsStyles.getActiveIcon(controller.activated)"
          [style]="iconsStyles.getActiveStyle(controller.activated)"
        ></i>
      </td>
      <td class="hidden xl:table-cell">
        <span
          pTooltip="{{ controller.mainFWVersion }}"
          tooltipPosition="right"
          >{{
            customFunctions.getShortenedMainFW(controller.mainFWVersion)
          }}</span
        >
      </td>
      <td class="hidden xl:table-cell">
        {{ controller.lastUpdate | date: "yyyy-MM-dd, HH:mm" }}
      </td>
      <td class="hidden xl:table-cell">{{ controller.deviceClientVersion }}</td>

      @if (showAdminFields()) {
        <td class="hidden lg:table-cell !text-center">
          {{ controller.emCount }}
        </td>
        <td class="hidden lg:table-cell !text-center">
          {{ controller.inverterCount }}
        </td>
        <td class="hidden lg:table-cell !text-center">
          {{ controller.emsCount }}
        </td>
        <td class="hidden lg:table-cell !text-center">
          {{ controller.ioAddonCount }}
        </td>
      }
    </tr>
  </ng-template>
</p-table>
